import React from "react";
import { Form, Select, FormInstance, Input } from "antd";
import LogisticsCompany from "@/enum/LogisticsCompany";
import { getFormLayout } from "@/util";
import { Rule } from "antd/lib/form";

// 京东电子面单参数
const JdAccountMapping = {
  [LogisticsCompany.JD_EXPRESS]: [{ key: "username", name: "商家编码", type: "input", required: true }],
  [LogisticsCompany.JD_HPCP]: [{ key: "username", name: "事业部编号", type: "input", required: true }],
  [LogisticsCompany.JDKY]: [{ key: "username", name: "事业部编号", type: "input", required: true }],
  JDL: [{ key: "username", name: "商家编码", type: "input", required: true }],
};

interface JDExpressFormProps {
  form?: FormInstance<JDExpressFormValues>;
}

export interface JDExpressFormValues {
  username?: string;

  logisticsCompany: LogisticsCompany.JDKY | LogisticsCompany.JD_EXPRESS | LogisticsCompany.JD_HPCP | "JDL";
}

const [formLayout] = getFormLayout(7);

const JDExpressForm: React.FC<JDExpressFormProps> = (props) => {
  const [form] = Form.useForm<JDExpressFormValues>(props.form);

  return (
    <Form form={form} initialValues={{ logisticsCompany: "JDL" }}>
      <Form.Item label="快递公司" name="logisticsCompany" {...formLayout}>
        <Select style={{ width: "300px" }}>
          <Select.Option key="JDL" value="JDL">
            京东快递-非店铺开通（外单账号）
          </Select.Option>
          <Select.Option key={LogisticsCompany.JD_EXPRESS} value={LogisticsCompany.JD_EXPRESS}>
            京东快递-店铺开通
          </Select.Option>
          <Select.Option key={LogisticsCompany.JDKY} value={LogisticsCompany.JDKY}>
            京东快运-店铺开通
          </Select.Option>
          <Select.Option key={LogisticsCompany.JD_HPCP} value={LogisticsCompany.JD_HPCP}>
            京东大件-店铺开通
          </Select.Option>
        </Select>
      </Form.Item>

      <Form.Item noStyle shouldUpdate>
        {(form) => {
          const logisticsCompany = form.getFieldValue("logisticsCompany");

          const formParams = JdAccountMapping[logisticsCompany];

          return formParams?.map?.((params) => {
            const { type, key, name, required } = params;

            if (type === "input" || type === "password") {
              const rules: Rule[] = [];

              if (required) {
                rules.push({
                  required: true,
                  message: `${name}必须填写`,
                });
              }

              return (
                <Form.Item label={name} key={key} name={key} rules={rules} {...formLayout}>
                  <Input type={type} style={{ width: "300px" }} />
                </Form.Item>
              );
            }

            return null;
          });
        }}
      </Form.Item>
    </Form>
  );
};

export default React.memo(JDExpressForm);
